const routes = {
  auth: '/auth',
  dashboardPage: '/app',
  login: '/login',
  root: '/'
}

const infoRoutes = {
  installationPage: `/installation`,
  landingPage: routes.root
}

const publicRoutes = {
  bugHunterStatistics: `/public/bug-hunter-statistics`,
  timeTracking: `/public/time-tracking`
}

const dashboardRoutes = {
  dashboardPage: `${routes.dashboardPage}/dashboard`,
  newGiftPage: `${routes.dashboardPage}/gifts/new`,
  editGiftPage: `${routes.dashboardPage}/gifts/:id`,
  giftRequestsPage: `${routes.dashboardPage}/gifts/requests`,
  giftsManagementPage: `${routes.dashboardPage}/gifts`,
  settingPage: `${routes.dashboardPage}/settings`,
  transfersPage: `${routes.dashboardPage}/transfers`,
  teamManagementPage: `${routes.dashboardPage}/team`,
  usersNoKudos: `${routes.dashboardPage}/users/noKudos`,
  statisticalsPage: `${routes.dashboardPage}/statisticals`,
  usersTopPage: `${routes.dashboardPage}/users/top`,
  usersTopDetailPage: `${routes.dashboardPage}/users/top/detail`,
  kudosStatisticPage: `${routes.dashboardPage}/users/statistics`,
  timeTrackingPage: `${routes.dashboardPage}/time-tracking`,
}

const authRoutes = {
  authSuccess: `${routes.auth}/success/:accessToken`
}

export {
  routes,
  authRoutes,
  infoRoutes,
  publicRoutes,
  dashboardRoutes
}
